var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert bg-danger radius-small font-md font-weight-600 clr-white py-1 px-2 flex-center shadow-type-5"},[_c('span',[_vm._v(_vm._s(_vm.message))])])
}
var staticRenderFns = []

export { render, staticRenderFns }